export default function (influencer) {
  if (influencer.decisions) {
    return Object.keys(influencer.decisions).reduce(
      function (accumulator, key) {
        const service = influencer.decisions[key]
        if (service.service_picto)
          accumulator.services.push(service.short_name_en)
        return accumulator
      },
      { services: [] }
    )
  }
}
